import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import md5 from "md5";
import request from "./request";
export function createUserThroughInsurance(_x) { return _createUserThroughInsurance.apply(this, arguments); }
function _createUserThroughInsurance() { _createUserThroughInsurance = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(data) { var resp; return _regeneratorRuntime.wrap(function _callee$(_context) { while (1) {
    switch (_context.prev = _context.next) {
        case 0:
            _context.next = 2;
            return request.post("/api/v1/online/login/createUserThroughInsurance", Object.assign({}, data, { useSubmitTime: true, inlineError: true }));
        case 2:
            resp = _context.sent;
            return _context.abrupt("return", resp.data);
        case 4:
        case "end": return _context.stop();
    }
} }, _callee); })); return _createUserThroughInsurance.apply(this, arguments); }
export function createUser(_x2) { return _createUser.apply(this, arguments); }
function _createUser() { _createUser = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(data) { var resp; return _regeneratorRuntime.wrap(function _callee2$(_context2) { while (1) {
    switch (_context2.prev = _context2.next) {
        case 0:
            _context2.next = 2;
            return request.post("/api/v1/online/login/createUser", Object.assign({}, data, { referUrl: data.referUrl, pwd: data.pwd ? md5(data.pwd) : null, mobileZone: data.mobileZone, acceptpromotePH: "Y", acceptpromoteEM: "Y", acceptpromotepp: "Y", acceptPrivateNum: "Y", acceptTc: "N", useSubmitTime: true, inlineError: true }));
        case 2:
            resp = _context2.sent;
            return _context2.abrupt("return", resp.data);
        case 4:
        case "end": return _context2.stop();
    }
} }, _callee2); })); return _createUser.apply(this, arguments); }
